import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[bllColumn]',
})
export class BllTableColumnDirective {
  constructor(public template: TemplateRef<any>) {}
  @Input() class: string = '';
  @Input() ngClass: string = '';
  @Input() header: string;
  @Input()
  set width(value: string) {
    if (value.includes('%')) {
      this.actualWidth.unit = '%';
    } else if (!value.includes('px')) {
      console.warn(`width should be % or px. '${value}' was given`);
    }
    this.styles = {
      minWidth: value,
      maxWidth: value,
      flexBasis: value,
    };
    this.actualWidth.value = Number(value.replace(this.actualWidth.unit, ''));
    this._width = value;
  }

  get width() {
    return this._width;
  }
  actualWidth: { value: number; unit: 'px' | '%' } = {
    value: null,
    unit: 'px',
  };

  styles: {
    minWidth: string;
    maxWidth: string;
    flexBasis: string;
  };
  private _width: string;
  @Input() sortable: boolean;
  sorted: 'desc' | 'asc' | null = null;
}
